
interface NumberFormatterProps {
  value: number;
}

export default (props: NumberFormatterProps) => (
  <span>{props.value.toLocaleString()}</span>
)